/**
 * CPF/CNPJ check digits, the same rules the API validates (`CommonValidationSchemas.taxId`).
 * bodyprint-web only checks the shape (`regex.cpf` / `regex.cnpj` in `utils/data.ts`).
 */
export const onlyDigits = (value?: string | null) => (value ?? '').replace(/\D/g, '');

export const isValidCpf = (value?: string | null) => {
  const cpf = onlyDigits(value);
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

  const checkDigit = (length: number) => {
    let sum = 0;
    for (let i = 0; i < length; i++) sum += Number(cpf[i]) * (length + 1 - i);
    const remainder = (sum * 10) % 11;
    return remainder === 10 ? 0 : remainder;
  };

  return checkDigit(9) === Number(cpf[9]) && checkDigit(10) === Number(cpf[10]);
};

export const isValidCnpj = (value?: string | null) => {
  const cnpj = onlyDigits(value);
  if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;

  const checkDigit = (base: string, weights: number[]) => {
    const sum = weights.reduce((total, weight, i) => total + Number(base[i]) * weight, 0);
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const weights2 = [6, ...weights1];
  return (
    checkDigit(cnpj.slice(0, 12), weights1) === Number(cnpj[12]) &&
    checkDigit(cnpj.slice(0, 13), weights2) === Number(cnpj[13])
  );
};

export const isValidTaxId = (value?: string | null) => isValidCpf(value) || isValidCnpj(value);
